import { useNavigate } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  category: string;
  categorySlug: string;
  views: number;
  duration: string;
  date: string;
  hot?: boolean;
  featured?: boolean;
  size?: 'normal' | 'large';
}

function formatViews(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return String(n);
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  category,
  categorySlug,
  views,
  duration,
  date,
  hot,
  size = 'normal',
}: VideoCardProps) {
  const navigate = useNavigate();

  return (
    <article
      className="group cursor-pointer"
      onClick={() => { navigate(`/article/${id}`); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[16/9]'
      }`}>
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded">
          {duration}
        </div>
        {hot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
            热门
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className={`font-semibold text-foreground-950 line-clamp-2 leading-snug mb-2 transition-colors group-hover:text-primary-500 ${
        size === 'large' ? 'text-base md:text-lg' : 'text-sm md:text-base'
      }`}>
        {title}
      </h3>

      <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
        <span
          className="text-primary-500 font-medium cursor-pointer hover:underline whitespace-nowrap"
          onClick={(e) => { e.stopPropagation(); navigate(`/category/${categorySlug}`); }}
        >
          {category}
        </span>
        <span className="flex items-center gap-1 whitespace-nowrap">
          <i className="ri-eye-line"></i>
          {formatViews(views)}
        </span>
        <span className="whitespace-nowrap">{date}</span>
      </div>
    </article>
  );
}